// extracted by mini-css-extract-plugin
export default {"toggleBtn":"toggleBtn--xej0x","quote":"quote--cW5Wn","mailContent":"mailContent--U1hTQ","quoteContent":"quoteContent--aYb3V"};